import React from "react";
import BookNowsec1 from "./BookNow/BookNowsec1";
import BookNowsec2 from "./BookNow/BookNowsec2";
import BookNowsec3 from "./BookNow/BookNowsec3";
const BookNow = () => {
  return (
    <div>
      <BookNowsec1 />
      <BookNowsec2 />
      <BookNowsec3 />
    </div>
  );
};

export default BookNow;
